import React from 'react';
import { Navbar } from '../navbar/navbar';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import Formsy from 'formsy-react';
import { Select } from 'formsy-react-components';
import { Row, Column, Button, Colors, Sizes } from 'react-foundation';
import { BurgerMenuContainer } from '../burger-menu/burger-menu';
import { ChangePasswordModal } from '../create-account/change-password';
import { BasicJobInfo } from './basic-job-info';
import { RequiredJobInfo } from './required-job-info';
import { ExtraJobInfo } from './extra-job-info';
import { BillingJobInfo } from './billing-job-info';
import {
  createJob,
  updateJob,
  getJob,
  clearJob
} from '../../state/jobs/actions';
import { getLanguages } from '../../state/languages/actions';
import { getJobTypes } from '../../state/job_types/actions';
import { jobTypeOptions, jobTypeConstants } from '../../utils';

const JobForm = React.createClass({
  getInitialState() {
    const { job } = this.props;

    return {
      formValid: false,
      jobType: job.get('job_type')
    };
  },

  componentWillMount() {
    const { dispatch, params } = this.props;
    dispatch(getLanguages());
    dispatch(getJobTypes());
    if (params.jobid) {
      dispatch(getJob(params.jobid));
    } else {
      dispatch(clearJob());
    }
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.job.get('job_type') !== this.props.job.get('job_type')) {
      return this.setState({
        jobType: nextProps.job.get('job_type')
      });
    }
    return undefined;
  },

  handleChange(event, value) {
    return this.setState({
      jobType: parseInt(value)
    });
  },

  renderNavbar() {
    const jobid = this.props.job.get('id');
    const title = jobid ? 'Edit Job' : 'Create a Job';

    return (
      <div id="outer-container">
        <BurgerMenuContainer
          pageWrapId={'page-wrap'}
          outerContainerId="outer-container"
        />
        <Navbar {...this.props} title={title} />
      </div>
    );
  },

  handleValid() {
    this.setState({ formValid: true });
  },

  handleInvalid() {
    this.setState({ formValid: false });
  },

  submit(formData) {
    const id = this.props.job.get('id');
    if (id) {
      this.props.onUpdate(formData, id);
    } else {
      this.props.onCreate(formData);
    }
  },

  renderMain() {
    const types = this.props.jobTypes;
    const jobTypes = [
      {
        value: '',
        label: 'Select a job type'
      },
      ...types
    ];
    const { job, profile } = this.props;
    const { jobType } = this.state;
    const isDisabled =
      job.get('status') === 'Interpreters applied to job' ||
      job.get('status') === 'Assigned to interpreter';

    return (
      <div className="job-form-container">
        <Formsy.Form
          onValidSubmit={this.submit}
          onValid={this.handleValid}
          onInvalid={this.handleInvalid}
          disabled={isDisabled}
        >
          <Row className="grid-x">
            <Column small={12} medium={4}>
              <div className="form-panel">
                <div className="heading">Job Info</div>
                <hr />
                <Select
                  label="Job Type"
                  options={jobTypes}
                  name="job_type"
                  required
                  value={job.get('job_type') || ''}
                  onChange={this.handleChange}
                />
                <BasicJobInfo job={job} jobType={jobType} />
                <RequiredJobInfo
                  job={job}
                  languages={this.props.languages}
                  jobType={jobType}
                />
              </div>
            </Column>
            <Column small={12} medium={4}>
              <BillingJobInfo job={job} profile={profile} />
            </Column>
            <Column small={12} medium={4}>
              <ExtraJobInfo job={job} jobType={jobType} />
            </Column>
          </Row>
          <hr />
          <Row>
            <Column small={8} centerOnSmall className="text-right">
              <Button
                sizes={Sizes.LARGE}
                color={Colors.PRIMARY}
                className="save-button"
                disabled={!this.state.formValid || isDisabled}
                type="submit"
                isExpanded
              >
                {job.get('id') ? 'Update' : 'Save'}
              </Button>
              {!this.state.formValid ? (
                <div className="required-fields-msg error-msg">
                  Please fill out all required fields marked with an asterisk.
                </div>
              ) : null}
              {isDisabled ? (
                <div className="required-fields-msg error-msg text-center">
                  This job has been applied to by an interpreter and cannot be
                  edited. Please contact fernando@nuancedinterpretation.com
                </div>
              ) : null}
            </Column>
          </Row>
        </Formsy.Form>
      </div>
    );
  },

  render() {
    return (
      <div>
        <ChangePasswordModal />
        {this.renderNavbar()}
        {this.renderMain()}
      </div>
    );
  }
});

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.get('isAuthenticated'),
    languages: state.languages.get('languages'),
    jobTypes: state.jobTypes.get('jobTypes'),
    job: state.jobs.get('job'),
    profile: state.auth.get('user')
  };
};
const mapDispatchToProps = dispatch => ({
  onCreate: formData => {
    dispatch(createJob(formData)).then(response => {
      if (response.ok) {
        dispatch(push('/jobs'));
      }
    });
  },
  onUpdate: (formData, id) => {
    dispatch(updateJob(formData, id)).then(response => {
      if (response.ok) {
        dispatch(push('/jobs'));
      }
    });
  },
  dispatch
});

export const JobFormContainer = connect(mapStateToProps, mapDispatchToProps)(
  JobForm
);



/** WEBPACK FOOTER **
 ** ./src/components/jobs/job-form.jsx
 **/